module.exports = __webpack_public_path__ + "8825a887e1d72aad739281fcc3eb83a6.svg";